module.exports = __webpack_public_path__ + "img/pic11.50172332.jpg";